import { cx } from 'utils';
import styles from './Actions.module.css';

export type ActionsProps = {
  className?: string;
};
export const Actions: React.FCWithChildren<ActionsProps> = ({ children, className }) => {
  return <footer className={cx(styles.root, className)}>{children}</footer>;
};
